import React from 'react';
import GymListFunctional from './components/gym-list-functional';
import './styles.scss';

const GymList = () => {
	return <GymListFunctional />;
};

export default GymList;
